import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import useDocumentTitle from "@/hooks/useDocumentTitle";

export default function Events() {
  useDocumentTitle("Events");
  const [events, setEvents] = useState(null);
  useEffect(() => {
    axios.get(`${API}/content/events`, { params: { limit: 60 } })
      .then(r => setEvents(r.data || []))
      .catch(() => setEvents([]));
  }, []);

  return (
    <div data-testid="events-page">
      <section className="container-wide pt-16 pb-8">
        <div className="font-accent text-[10px]" style={{ color: "var(--gi-gold)" }}>Events</div>
        <h1 className="mt-3 font-heading text-5xl sm:text-6xl leading-[1.02]" style={{ color: "var(--gi-maroon)" }}>Upcoming Events</h1>
        <div className="hair-divider my-8 max-w-xs" />
      </section>
      <section className="container-wide pb-24">
        {events === null && <p className="text-sm" style={{ color: "var(--gi-muted)" }}>Loading…</p>}
        {events?.length === 0 && (
          <p className="text-sm" style={{ color: "var(--gi-muted)" }} data-testid="events-empty">No events are currently scheduled.</p>
        )}
        {events?.length > 0 && (
          <div className="border-t" style={{ borderColor: "var(--gi-divider)" }}>
            {events.map(e => {
              const d = e.starts_at ? new Date(e.starts_at) : null;
              return (
                <div key={e.id} className="grid gap-8 sm:grid-cols-[140px_1fr_auto] py-8 border-b items-center" style={{ borderColor: "var(--gi-divider)" }} data-testid={`event-card-${e.slug || e.id}`}>
                  <div>
                    <div className="font-heading text-5xl leading-none" style={{ color: "var(--gi-maroon)" }}>{d ? d.getDate() : "—"}</div>
                    <div className="font-accent text-[10px] mt-2" style={{ color: "var(--gi-muted)" }}>{d ? d.toLocaleString(undefined, { month: "short", year: "numeric" }) : "Date TBC"}</div>
                  </div>
                  <div>
                    <h3 className="font-heading text-2xl" style={{ color: "var(--gi-charcoal)" }}>{e.title}</h3>
                    <p className="mt-1 text-sm" style={{ color: "var(--gi-muted)" }}>{e.location || (e.is_online ? "Online" : "TBA")}</p>
                    {e.summary && <p className="mt-2 text-sm" style={{ color: "var(--gi-charcoal-2)" }}>{e.summary}</p>}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </section>
    </div>
  );
}
